import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';
import { PICKLEBALL_PLACEHOLDER_IMAGE } from '@pickleballinc/ui/components/global/utils/constants';
import clsx from 'clsx';

interface ArticleCardProps {
	imageUrl: string;
	title: string;
	description?: string;
	type?: 'paginationContain' | 'paginationCover' | 'latest' | 'popular' | 'favorited';
	showDate?: boolean;
	publishedAt?: string;
	alt?: string;
	isTournaments?: boolean;
}

export const ArticleCard = ({
	imageUrl,
	title,
	description,
	type = 'paginationCover',
	showDate,
	publishedAt,
	alt,
	isTournaments = false
}: ArticleCardProps) => {
	const typeStyles = {
		paginationContain: 'w-full max-w-[382px]',
		paginationCover: 'w-full max-w-[382px]',
		latest: 'w-full max-w-[799px]',
		popular: 'w-full max-w-[382px]',
		favorited: 'w-full max-w-[480px]'
	};
	const imageAspectRatio = {
		paginationContain: 'aspect-[382/152]',
		paginationCover: 'aspect-[382/326]',
		latest: 'aspect-[799/397]',
		popular: 'aspect-[382/326]',
		favorited: 'aspect-[480/410]'
	};

	const formatDate = (dateString: string) => {
		const date = new Date(dateString);
		return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
	};

	return (
		<div
			className={clsx(
				'flex cursor-pointer flex-col rounded-lg bg-white p-2 text-gray-900 shadow-md sm:p-4 sm:shadow-transparent',
				typeStyles[type],
				isTournaments && 'hover:bg-blue-500 hover:text-white'
			)}
		>
			<div className={clsx('overflow-hidden rounded sm:rounded-2xl', imageAspectRatio[type])}>
				<img
					src={`${getCDNURL(imageUrl || PICKLEBALL_PLACEHOLDER_IMAGE, 800, 320)}`}
					alt={alt ? alt : title}
					className={clsx('size-full', { 'object-contain': isTournaments || !imageUrl, 'object-cover': !(isTournaments || !imageUrl) })}
					aria-hidden="true"
				/>
			</div>

			<div>
				{(showDate && type === 'paginationContain') ||
					(type === 'paginationCover' && publishedAt && <p className="my-2 text-xs">{formatDate(publishedAt)}</p>)}
				<h3 className="mt-2 line-clamp-4 text-base font-medium sm:text-xl">{title}</h3>
				{description ? (
					<p
						className={clsx('mt-2 hidden text-sm sm:line-clamp-2', {
							'group-hover:!text-white': isTournaments,
							'text-gray-500': !isTournaments
						})}
					>
						{description}
					</p>
				) : null}
			</div>
		</div>
	);
};
